<template>
    <div class="l-no-data text-center">
        <img :src="icon" alt="No Data" class="placeholder-list" data-test-id="l-no-data-image" />

        <h4 class="color-grey" data-test-id="l-no-data-text">
            {{ text }}
        </h4>

        <h4
            v-show="btnShow"
            class="color-primary clickable"
            data-test-id="l-no-data-btn"
            tabindex="0"
            @click="btnHandler()"
            @keyup.enter="btnHandler()"
        >
            {{ btnText }}
        </h4>
    </div>
</template>

<script>
import icon from "@/img/icons/nodata.png";

export default {
    props: {
        icon: {
            type: String,
            default: icon,
        },
        text: {
            type: String,
            required: true,
        },
        btnShow: {
            type: Boolean,
            default: false,
        },
        btnText: {
            type: String,
            default: "",
        },
        btnHandler: {
            type: Function,
            default: () => {},
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped>
.l-no-data {
    padding-top: 18px;
}

.l-no-data h4 {
    white-space: pre-wrap;
}
</style>
